export const environment = {
    production: false,
    domain: 'dev-auth.ocadohub.com',
    clientId: 'sWh8D1dxUVD8FVloWjdbYzdKITCDBVfo',
    redirect_uri: 'https://tst.ocadohub.com/',
     audience: 'https://suphub.ocadohub.com/v1'
};
